import { BillingPlanId } from '@/modules/billing/constants/BillingPlanId';
import { ProductKey } from '@/modules/estate/enums/ProductKey';

export class BillingPlanIdMapper {
  static getProductKey(billingPlanId: BillingPlanId): string | null {
    switch (billingPlanId) {
      case BillingPlanId.INDIVIDUAL_STANDARD_PLAN:
        return ProductKey.INDIVIDUAL_STANDARD_PLAN;
      case BillingPlanId.COUPLES_STANDARD_PLAN:
        return ProductKey.COUPLES_STANDARD_PLAN;
      case BillingPlanId.INDIVIDUAL_BASIC_PLAN:
        return ProductKey.INDIVIDUAL_BASIC_PLAN;
      case BillingPlanId.COUPLES_BASIC_PLAN:
        return ProductKey.COUPLES_BASIC_PLAN;
      case BillingPlanId.INDIVIDUAL_COMPLETE_PLAN:
        return ProductKey.INDIVIDUAL_COMPLETE_PLAN;
      case BillingPlanId.COUPLES_COMPLETE_PLAN:
        return ProductKey.COUPLES_COMPLETE_PLAN;
      case BillingPlanId.INDIVIDUAL_PROFESSIONAL_EXECUTOR:
        return ProductKey.INDIVIDUAL_PROFESSIONAL_EXECUTOR_PLAN;
      case BillingPlanId.COUPLES_PROFESSIONAL_EXECUTOR:
        return ProductKey.COUPLES_PROFESSIONAL_EXECUTOR_PLAN;
      case BillingPlanId.INDIVIDUAL_CUSTOM:
        return ProductKey.INDIVIDUAL_CUSTOM_PLAN;
      case BillingPlanId.COUPLES_CUSTOM:
        return ProductKey.COUPLES_CUSTOM_PLAN;
      case BillingPlanId.INDIVIDUAL_DIGITAL_VAULT:
        return ProductKey.INDIVIDUAL_DIGITAL_VAULT_PLAN;
      default:
        return null;
    }
  }

  static getRecurringProductKey(billingPlanId: BillingPlanId): string | null {
    switch (billingPlanId) {
      case BillingPlanId.INDIVIDUAL_STANDARD_PLAN:
        return ProductKey.INDIVIDUAL_STANDARD_PLAN_RECURRING;
      case BillingPlanId.COUPLES_STANDARD_PLAN:
        return ProductKey.COUPLES_STANDARD_PLAN_RECURRING;
      case BillingPlanId.INDIVIDUAL_BASIC_PLAN:
        return ProductKey.INDIVIDUAL_BASIC_PLAN_RECURRING;
      case BillingPlanId.COUPLES_BASIC_PLAN:
        return ProductKey.COUPLES_BASIC_PLAN_RECURRING;
      case BillingPlanId.INDIVIDUAL_COMPLETE_PLAN:
        return ProductKey.INDIVIDUAL_COMPLETE_PLAN_RECURRING;
      case BillingPlanId.COUPLES_COMPLETE_PLAN:
        return ProductKey.COUPLES_COMPLETE_PLAN_RECURRING;
      case BillingPlanId.INDIVIDUAL_PROFESSIONAL_EXECUTOR:
        return ProductKey.INDIVIDUAL_PROFESSIONAL_EXECUTOR_PLAN_RECURRING;
      case BillingPlanId.COUPLES_PROFESSIONAL_EXECUTOR:
        return ProductKey.COUPLES_PROFESSIONAL_EXECUTOR_PLAN_RECURRING;
      case BillingPlanId.INDIVIDUAL_CUSTOM:
        return ProductKey.INDIVIDUAL_CUSTOM_PLAN_RECURRING;
      case BillingPlanId.COUPLES_CUSTOM:
        return ProductKey.COUPLES_CUSTOM_PLAN_RECURRING;
      case BillingPlanId.INDIVIDUAL_DIGITAL_VAULT:
        return ProductKey.INDIVIDUAL_DIGITAL_VAULT_PLAN_RECURRING;
      default:
        return null;
    }
  }

  static getBillingPlanId(productKey: ProductKey): BillingPlanId | null {
    switch (productKey) {
      case ProductKey.INDIVIDUAL_STANDARD_PLAN:
      case ProductKey.INDIVIDUAL_STANDARD_PLAN_RECURRING:
        return BillingPlanId.INDIVIDUAL_STANDARD_PLAN;
      case ProductKey.COUPLES_STANDARD_PLAN:
      case ProductKey.COUPLES_STANDARD_PLAN_RECURRING:
        return BillingPlanId.COUPLES_STANDARD_PLAN;
      case ProductKey.INDIVIDUAL_BASIC_PLAN:
      case ProductKey.INDIVIDUAL_BASIC_PLAN_RECURRING:
        return BillingPlanId.INDIVIDUAL_BASIC_PLAN;
      case ProductKey.COUPLES_BASIC_PLAN:
      case ProductKey.COUPLES_BASIC_PLAN_RECURRING:
        return BillingPlanId.COUPLES_BASIC_PLAN;
      case ProductKey.INDIVIDUAL_COMPLETE_PLAN:
      case ProductKey.INDIVIDUAL_COMPLETE_PLAN_RECURRING:
        return BillingPlanId.INDIVIDUAL_COMPLETE_PLAN;
      case ProductKey.COUPLES_COMPLETE_PLAN:
      case ProductKey.COUPLES_COMPLETE_PLAN_RECURRING:
        return BillingPlanId.COUPLES_COMPLETE_PLAN;
      case ProductKey.INDIVIDUAL_PROFESSIONAL_EXECUTOR_PLAN:
      case ProductKey.INDIVIDUAL_PROFESSIONAL_EXECUTOR_PLAN_RECURRING:
        return BillingPlanId.INDIVIDUAL_PROFESSIONAL_EXECUTOR;
      case ProductKey.COUPLES_PROFESSIONAL_EXECUTOR_PLAN:
      case ProductKey.COUPLES_PROFESSIONAL_EXECUTOR_PLAN_RECURRING:
        return BillingPlanId.COUPLES_PROFESSIONAL_EXECUTOR;
      case ProductKey.INDIVIDUAL_CUSTOM_PLAN:
      case ProductKey.INDIVIDUAL_CUSTOM_PLAN_RECURRING:
        return BillingPlanId.INDIVIDUAL_CUSTOM;
      case ProductKey.COUPLES_CUSTOM_PLAN:
      case ProductKey.COUPLES_CUSTOM_PLAN_RECURRING:
        return BillingPlanId.COUPLES_CUSTOM;
      case ProductKey.ADVISOR_PRO:
        return BillingPlanId.FINANCIAL_ADVISOR_PRO;
      case ProductKey.ADVISOR_PRO_ANNUAL:
        return BillingPlanId.FINANCIAL_ADVISOR_PRO_ANNUAL;
      case ProductKey.INDIVIDUAL_DIGITAL_VAULT_PLAN:
        return BillingPlanId.INDIVIDUAL_DIGITAL_VAULT;
      case ProductKey.INDIVIDUAL_DIGITAL_VAULT_PLAN_RECURRING:
        return BillingPlanId.INDIVIDUAL_DIGITAL_VAULT;
      default:
        return null;
    }
  }

  static isCouplesPlan(billingPlanId: BillingPlanId): boolean {
    return this.couplesPlans.includes(billingPlanId);
  }

  static get couplesPlans(): BillingPlanId[] {
    return [
      BillingPlanId.COUPLES_ESSENTIAL_PLAN,
      BillingPlanId.COUPLES_STANDARD_PLAN,
      BillingPlanId.COUPLES_BASIC_PLAN,
      BillingPlanId.COUPLES_PLUS_PLAN,
      BillingPlanId.COUPLES_COMPLETE_PLAN,
      BillingPlanId.COUPLES_PROFESSIONAL_EXECUTOR,
      BillingPlanId.COUPLES_CUSTOM,
      BillingPlanId.LEGACY_COUPLES_ESSENTIAL_PLAN
    ];
  }
}
